import { render, staticRenderFns } from "./dialogues.vue?vue&type=template&id=5d3ae293"
import script from "./dialogues.vue?vue&type=script&lang=js"
export * from "./dialogues.vue?vue&type=script&lang=js"
import style0 from "./dialogues.vue?vue&type=style&index=0&id=5d3ae293&prod&lang=less"
import style1 from "./dialogues.vue?vue&type=style&index=1&id=5d3ae293&prod&lang=less"
import style2 from "./dialogues.vue?vue&type=style&index=2&id=5d3ae293&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports